<template>
    <ag-loading v-if="loading" class="ag-loading" />
    <div class="ag-modal ag-company-modal" id="companyModal" tabindex="-1" role="dialog" aria-labelledby="ag-modal"
        aria-hidden="true">
        <div role="document">
            <div v-if="!loading" class="modal-content">
                <div class="modal-header">
                    <h3>{{ this.editModal ? $t("editCompany") : $t("createCompany") }}</h3>
                    <span class="close-icon" @click="closeCompanyModal">&times;</span>
                </div>
                <form method="post" @submit.prevent="submitCompany">
                    <div class="modal-body">
                        <div class="ag-modal-form w-100">
                            <ul class="ag-modal-form-list">
                                <li>
                                    <span class="bold-text">{{ $t("companyname") }}: <span
                                            class="required-field">*</span></span>
                                    <span class="value">
                                <li class="form-group">
                                    <input type="text" maxlength="100" name="companyName" v-model="companyName"
                                        class="form-control" required />
                                </li>
                                </span>
                                </li>
                                <li>
                                    <span class="bold-text">{{ $t("address1") }}: </span>
                                    <span class="value">
                                <li class="form-group">
                                    <input type="text" maxlength="200" name="address1" v-model="address1"
                                        class="form-control" />
                                </li>
                                </span>
                                </li>
                                <li>
                                    <span class="bold-text">{{ $t("address2") }}: </span>
                                    <span class="value">
                                <li class="form-group">
                                    <input type="text" maxlength="200" name="address2" v-model="address2"
                                        class="form-control" />
                                </li>
                                </span>
                                </li>
                                <li>
                                    <span class="bold-text">{{ $t("city") }}: </span>
                                    <span class="value">
                                <li class="form-group">
                                    <input type="text" maxlength="100" name="city" v-model="city"
                                        class="form-control" />
                                </li>
                                </span>
                                </li>
                                <li>
                                    <span class="bold-text">{{ $t("stateProvince") }}: </span>
                                    <span class="value">
                                <li class="form-group">
                                    <input type="text" maxlength="100" name="state" v-model="state"
                                        class="form-control" />
                                </li>
                                </span>
                                </li>
                                <li>
                                    <span class="bold-text">{{ $t("postalCode") }}: </span>
                                    <span class="value">
                                <li class="form-group">
                                    <input type="text" maxlength="50" name="postalCode" v-model="postalCode"
                                        class="form-control" />
                                </li>
                                </span>
                                </li>
                                <li>
                                    <span class="bold-text">{{ $t("country") }}: </span>
                                    <span class="value">
                                <li class="form-group">
                                    <select name="country" v-model="country" class="form-control" style="width: 65%;">
                                        <option v-for="(country, index) in countries" :key="index"
                                            :value="country.value">
                                            {{ country.text }}
                                        </option>
                                    </select>
                                </li>
                                </span>
                                </li>
                                <li>
                                    <span class="bold-text">{{ $t("contactName") }}: </span>
                                    <span class="value">
                                <li class="form-group">
                                    <input type="text" maxlength="200" name="contactName" v-model="contactName"
                                        class="form-control" />
                                </li>
                                </span>
                                </li>
                                <li>
                                    <span style="margin-left: 5px;" class="bold-text">{{ $t("contactPhone") }}: </span>
                                    <span class="value">
                                        <input type="text" style="width: 40%;" maxlength="100" name="contactPhone"
                                            @input="checkPhoneExtension" v-model="contactPhone" class="form-control" />
                                <li class="form-group">
                                    <span class="ext-input mr-2">{{ $t("ext") }}:</span>
                                    <input type="text" style="max-width: 22%;" maxlength="5" name="phoneExtension"
                                        v-model="phoneExtension" class="form-control" :disabled="!contactPhone" />
                                </li>
                                </span>
                                </li>
                                <li>
                                    <span class="bold-text">{{ $t("contactEmail") }}: </span>
                                    <span class="value">
                                <li class="form-group">
                                    <input type="email" maxlength="200" name="contactEmail" v-model="contactEmail"
                                        class="form-control" />
                                </li>
                                </span>
                                </li>
                                <li>
                                    <span class="bold-text">{{ $t("contactFax") }}: </span>
                                    <span class="value">
                                <li class="form-group">
                                    <input type="text" maxlength="100" name="contactFax" v-model="contactFax"
                                        class="form-control" />
                                </li>
                                </span>
                                </li>
                                <li style="margin-top: 20px; margin-right: 20px;">
                                    <span class="bold-text"><span class="required-field">*</span>{{ $t("requiredFields")
                                        }}. </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" @click="closeCompanyModal" class="
                  border-0
                  ag-button ag-button_radius
                  pr-4
                  pl-4
                  ag-button_secondary
                " data-dismiss="modal">
                            {{ $t("cancel") }}
                        </button>
                        <button type="submit" :disabled="loading" class="
                  border-0
                  ag-button ag-button_radius
                  pr-4
                  pl-4
                  ag-button_primary
                  float-inline-end
                ">
                            {{ $t("save") }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { useStore } from "@/store";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { notify } from "@kyvg/vue3-notification";
import AgLoading from "@/components/ag-loading/index.vue";
import axiosApi from "@/store/axiosAgsc";

const store = useStore();

let selectedPartner = localStorage.getItem("partner");
let partner = JSON.parse(selectedPartner);

export default {
    name: "ag-company-modal",
    components: {
        AgLoading
    },
    data() {
        return {
            companyName: null,
            companyShortName: null,
            address1: null,
            address2: null,
            city: null,
            state: null,
            postalCode: null,
            country: null,
            contactName: null,
            contactPhone: null,
            phoneExtension: null,
            contactEmail: null,
            contactFax: null,
            partnerId: null,
            loading: false,
            companyGuid: null,
            editModal: false,
            countries: {}
        };
    },
    async created() {
        this.loading = true;
        this.getCountryList();
    },
    methods: {

        checkPhoneExtension() {
            if (!this.contactPhone) {
                this.phoneExtension = null;
            }
        },

        checkValidations() {
            const validationRules = [
                { field: this.companyName, message: "companyNameVal", pattern: /[<>?"]/ },
                { field: this.address1, message: "address1Val", pattern: /[<>?"]/ },
                { field: this.address2, message: "address2Val", pattern: /[<>?"]/ },
                { field: this.city, message: "cityVal", pattern: /[<>?"]/ },
                { field: this.state, message: "stateVal", pattern: /[<>?"]/ },
                { field: this.postalCode, message: "postalCodeVal", pattern: postal => !this.postalCodeVal(postal) },
                { field: this.contactName, message: "contactNameVal", pattern: /[<>?"]/ },
                { field: this.contactPhone, message: "contactPhoneVal", pattern: phone => !this.phoneNumberVal(phone) },
                { field: this.phoneExtension, message: "extVal", pattern: phoneExt => !this.phoneExtensionVal(phoneExt) },
                { field: this.contactEmail, message: "emailVal", pattern: /[<>?"]/ },
                { field: this.contactFax, message: "contactFaxVal", pattern: phone => !this.phoneNumberVal(phone) }
            ];

            let hasError = false;

            validationRules.forEach(rule => {
                if (rule.field && rule.field.length > 0) {
                    if (typeof rule.pattern === 'function') {
                        if (rule.pattern(rule.field)) {
                            notify({
                                title: this.$t('warning'),
                                text: this.$t(rule.message),
                                type: 'warning',
                                duration: 4000
                            });
                            hasError = true;
                        }
                    } else if (rule.pattern.test(rule.field)) {
                        notify({
                            title: this.$t('warning'),
                            text: this.$t(rule.message),
                            type: 'warning',
                            duration: 4000
                        });
                        hasError = true;
                    }
                }
            });

            return hasError;
        },

        closeCompanyModal() {
            this.$emit("close-popup");
        },

        editCompany(company) {
            this.loading = true;
            this.editModal = true;
            this.companyName = company.companyName;
            this.companyShortName = company.companyShortName;
            this.address1 = company.address1;
            this.address2 = company.address2;
            this.city = company.city;
            this.state = company.state;
            this.postalCode = company.postalCode;
            this.country = company.country;
            this.contactName = company.contactName;
            if (company.contactPhone && company.contactPhone.includes("x")) {
                const [phone, extension] = company.contactPhone.split("x");
                this.contactPhone = phone.trim();
                this.phoneExtension = extension.trim();
            } else {
                this.contactPhone = company.contactPhone;
                this.phoneExtension = company.phoneExtension;
            }
            this.contactEmail = company.contactEmail;
            this.contactFax = company.contactFax;
            this.companyGuid = company.companyGuid;
            this.loading = false;
        },

        getCountryList() {
            try {
                axiosApi.get(`Company/GetCountryOptions`).then((res) => {
                    if (res && res.data.statusCode == 200 && res.data.isSuccess) {
                        this.countries = res.data.entityData;
                        if (this.country == null)
                            this.country = this.countries[0].value;
                    } else {
                        notify({
                            title: this.$t("error"),
                            type: "error",
                            text: res.Message,
                            duration: 8000,
                        });
                    }
                });
            } catch (error) {
                notify({
                    title: this.$t("error"),
                    type: "error",
                    text: error,
                    duration: 8000,
                });
            } finally {
                this.loading = false;
            }
        },

        phoneNumberVal(phone) {
            const patterns = {
                us: /^[+]?(((\(\d{1,4}\))|(\d{1,4}))( |-))?((\(\d{1,4}\))|(\d{1,4}))( |-)?(\d{3,4})( |-)?(\d{3,4})$/,
                jp: /^0\d{1,3}-\d{2,4}-\d{4,4}$/
            };

            return Object.values(patterns).some(pattern => pattern.test(phone.trim()));
        },

        postalCodeVal(postalCode) {
            const pattern = /^[a-zA-Z0-9-]+$/;
            return pattern.test(postalCode.trim());
        },

        phoneExtensionVal(phoneExtension) {
            const pattern = /^\d{1,5}$/;
            return pattern.test(phoneExtension.trim());
        },

        async submitCompany() {
            try {
                if (this.checkValidations()) {
                    return;
                }

                this.loading = true;

                const formData = {
                    companyName: this.companyName,
                    address1: this.address1,
                    address2: this.address2,
                    city: this.city,
                    state: this.state,
                    postalCode: this.postalCode,
                    country: this.editModal ? (this.country == -1 ? null : this.country) : this.country,
                    contactName: this.contactName,
                    contactPhone: this.contactPhone,
                    phoneExtension: this.phoneExtension,
                    contactEmail: this.contactEmail,
                    contactFax: this.contactFax,
                    partnerId: localStorage.selectedScopeId ?? partner.id,
                    companyGuid: this.editModal ? this.companyGuid : null
                };

                const res = await store.dispatch(GeneralActionTypes.CREATE_OR_EDIT_COMPANY, formData);

                if (res && res.statusCode == 200 && res.isSuccess) {
                    this.$emit('company-list-updated');
                    this.closeCompanyModal();
                    notify({
                        title: this.editModal ? this.$t('companyUpdated') : this.$t('companyCreated'),
                        type: 'success',
                        duration: 4000,
                    });
                } else {
                    notify({
                        title: this.$t("error"),
                        type: "error",
                        text: res.Message,
                        duration: 8000,
                    });
                }
            } catch (error) {
                notify({
                    title: this.$t("error"),
                    type: "error",
                    text: error,
                    duration: 8000,
                });
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.ag-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.ag-modal {
    position: fixed;
    width: 50%;
    max-height: 95%;
    overflow-y: auto;
    border-radius: 10px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}

.ag-modal-form-list li {
    padding: 4px;
}

.ag-modal-form-list {
    margin-left: 30px;
}

.ag-modal-form-list li .bold-text {
    width: 33%;
    font-weight: bold;
    display: inline-block;
}

.ag-modal-form-list li input {
    width: 65%;
    padding: 5px;
    border-radius: 5px;
    border: 1px solid #ccc;
}

button {
    padding: 7px 22px;
}

.close-icon {
    cursor: pointer;
    font-size: 24px;
    color: #999;
    position: absolute;
    top: 10px;
    right: 10px;
}

.close-icon:hover {
    color: #000;
}

.ext-input {
    font-weight: bold;
    color: #5e5e5e;
    margin-left: 5%;
    width: 11%;
}

.modal-body {
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: auto;
    max-height: calc(80% - 100px);
}

.modal-footer {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    padding: 21px;
    border-top: 2px solid #f8f8f8;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 10px 25px #00000080;
    bottom: 0;
}

.modal-header {
    padding: 21px;
    display: flex;
    align-items: center;
    justify-content: center;

    h3 {
        font: normal normal 600 26px/42px;
        letter-spacing: 0px;
        color: #5e5e5e;
        font-weight: bold;
    }
}

.modal-header,
.modal-footer {
    padding: 15px;
    background-color: #f2f2f2;
    position: sticky;
    z-index: 1;
}

.modal-footer button {
    padding: 10px 30px !important;
    font-size: 16px !important;
}

.required-field {
    color: red;
}
</style>